module.exports = __webpack_public_path__ + "img/honor01.139aa3d6.webp";